var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 136,
    viewBox: "0 0 96 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7624_12323)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 124,
    r: 4,
    transform: "rotate(-90 8 124)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 124,
    r: 4,
    transform: "rotate(-90 28 124)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 124,
    r: 4,
    transform: "rotate(-90 48 124)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 124,
    r: 4,
    transform: "rotate(-90 68 124)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 124,
    r: 4,
    transform: "rotate(-90 88 124)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 100,
    r: 4,
    transform: "rotate(-90 8 100)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 100,
    r: 4,
    transform: "rotate(-90 28 100)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 100,
    r: 4,
    transform: "rotate(-90 48 100)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 100,
    r: 4,
    transform: "rotate(-90 68 100)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 100,
    r: 4,
    transform: "rotate(-90 88 100)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 76,
    r: 4,
    transform: "rotate(-90 8 76)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 76,
    r: 4,
    transform: "rotate(-90 28 76)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 76,
    r: 4,
    transform: "rotate(-90 48 76)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 76,
    r: 4,
    transform: "rotate(-90 68 76)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 76,
    r: 4,
    transform: "rotate(-90 88 76)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 52,
    r: 4,
    transform: "rotate(-90 8 52)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    r: 4,
    transform: "rotate(-90 28 52)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 52,
    r: 4,
    transform: "rotate(-90 48 52)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 52,
    r: 4,
    transform: "rotate(-90 68 52)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 52,
    r: 4,
    transform: "rotate(-90 88 52)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 28,
    r: 4,
    transform: "rotate(-90 8 28)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 4,
    transform: "rotate(-90 28 28)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 28,
    r: 4,
    transform: "rotate(-90 48 28)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 28,
    r: 4,
    transform: "rotate(-90 68 28)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 28,
    r: 4,
    transform: "rotate(-90 88 28)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 4,
    transform: "rotate(-90 8 4)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 4,
    transform: "rotate(-90 28 4)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 4,
    r: 4,
    transform: "rotate(-90 48 4)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 4,
    r: 4,
    transform: "rotate(-90 68 4)",
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 4,
    r: 4,
    transform: "rotate(-90 88 4)",
    fill: "#C9ADA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7624_12323",
    x: 0,
    y: 0,
    width: 96,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7624_12323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7624_12323",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternDesign);
export default __webpack_public_path__ + "static/media/PatternDesign.7876b68ef0e516dd0940400ca8b626ac.svg";
export { ForwardRef as ReactComponent };